interface LoadingProps
    extends React.DetailedHTMLProps<
        React.AllHTMLAttributes<HTMLDivElement>,
        HTMLDivElement> {
    className?: string;
}

export const LoadingComponent: React.FC<LoadingProps> = ({
    className,
    ...props
}) => {
    return (
        <div {...props}>
            <div className='bg-loading'>
                <div className="loader"></div>
            </div>
        </div>
        // )
    );
};

export default LoadingComponent;